import React, {useEffect} from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Text from '/component/base/Text';
import HealthJourneyTestIds from '/constant/TestIDs/HealthJourney';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import ClientPlan from './ClientPlan/ClientPlan';
import WhyFooter from './WhyFooter/WhyFooter';
import ClientMWL from './ClientMWL';
import ClientProgramDate from './ClientProgramDate';
import {styles} from './HealthJourney.style';

interface HealthJourneyProps {
  fetchstartDate?: {};
  fetchplanDetails?: {};
  fetchmyWhy?: {};
  onShowInfoPopover: () => void;
  mwlData: {};
  clientId: '';
  clientStartDate: {};
  clientPlanDetails: {};
  clientmyWhy: {};
}

export const HealthJourney: React.FC<HealthJourneyProps> = ({
  fetchstartDate = {},
  fetchplanDetails = {},
  fetchmyWhy = {},
  onShowInfoPopover = noop,
  mwlData = {},
  clientId = '',
  clientStartDate = {},
  clientPlanDetails = {},
  clientmyWhy = {},
  firstName = '',
}: any) => {
  const {tt} = useTranslation('clientHealthJourney');

  useEffect(() => {
    fetchstartDate(mwlData, clientId);
    fetchplanDetails(mwlData, clientId);
    fetchmyWhy(mwlData, clientId);
  }, []);

  const startDate = clientStartDate[clientId];
  const planDetails = clientPlanDetails[clientId];
  const myWhy = clientmyWhy[clientId];

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text
          variant="heading"
          style={styles.headerText}
          {...testProperties(HealthJourneyTestIds.clientJourneyHeader)}>
          {tt('heading', 'Client journey')}
        </Text>
      </View>
      <ClientProgramDate
        startDate={startDate}
        mwlData={mwlData?.data?.startDate}
      />
      <ClientMWL
        onShowInfoPopover={onShowInfoPopover}
        mwlData={mwlData}
        clientId={clientId}
      />
      <ClientPlan planDetails={planDetails} />
      <WhyFooter
        mwlData={mwlData?.data?.myWhy}
        myWhy={myWhy}
        firstName={firstName}
      />
    </View>
  );
};

export default HealthJourney;
